import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'enabled'
})
export class EnabledPipe implements PipeTransform {
	transform(value: any): any {
		return value ? 'Habilitado' : 'Deshabilitado';
	}
}
